WiseMetering.Views.DestroyAllocation = WiseMetering.Views.Modal.Destroy.extend({
    title: () => i18next.t('modal.title.allocations.destroy')
});
